import Cookie from "js-cookie";
import queryString from "query-string";
import { HS_SIGNUP_FORM, COOKIE_HS, IP_ENDPOINT } from "./config";
import debug from "debug";

const log = debug("velpic:singup:hs");

async function userIP() {
	try {
		const resp = await fetch(IP_ENDPOINT);
		const body = await resp.json();
		return body;
	} catch (e) {
		return null;
	}
}

// eslint-disable-next-line import/prefer-default-export
export async function postSignup(inputs) {

	const body = {
		hs_context: Cookie.get(COOKIE_HS),
		pageUrl: window.location.href,
		pageName: "Velpic Signup",
		...inputs,
	};

	if (window.HS_SEND_ENABLED !== true) {
		log("You're in a dev environment-  In prod the following will be sent to hubspot");
		log(body);
		return;
	}

	const userInfo = await userIP();
	if (userInfo) {
		body.ipAddress = userInfo.ip;
	}

	fetch(HS_SIGNUP_FORM, {
		method: "POST",
		mode: "no-cors",
		headers: { "Content-Type": "application/x-www-form-urlencoded" },
		body: queryString.stringify(body),
	}).then(
		response => null,
		error => null,
	);
}



// WEBPACK FOOTER //
// ./src/utils/hubspot.js